import { Component, OnInit, ElementRef, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AppInfoService } from 'src/app/adapters/app-info.service';

declare var UIkit: any;
interface TiscoModalDisplayModel {
    title: string;
    body: string;
    callBack: string,
    redirectTo: string,
    params: any
}
@Component({
    selector: 'app-tisco-modal',
    templateUrl: './tisco-modal.component.html',
    styleUrl: './tisco-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TiscoModalComponent implements OnInit {
    modalDisplay = signal<TiscoModalDisplayModel>({
        title: '',
        body: '',
        callBack: '',
        redirectTo: '',
        params: {}
    });

    constructor(private router: Router, public appInfo: AppInfoService) { }

    ngOnInit() { }

    show(modalSource) {
        this.modalDisplay.set(modalSource)
        UIkit.modal('.modal-common').show();
    }

    redirectCallBack() {
        const model = this.modalDisplay();
        if (model.callBack) {
            if (model.callBack == 'home' && this.appInfo.display() == false) {
                //location.reload();
                window.location.href = '/buy-insurance';
            }

            let params = model.params || {};

            document.querySelector('.modal-common').remove();
            this.router.navigate([model.callBack], { queryParams: params });
        } else if (model.redirectTo) {
            window.location.href = model.redirectTo;
        } else {
            UIkit.modal('.modal-common').hide();
        }
    }
}
